import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

import {
  NavLink,
  Link,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  ProfileLi,
  ProfileLabel,
  ProfileText,
  ProfileTitle,
  PrimaryButton,
  ProfileHeroFooter,
  OrderHistoryH1,
  VerticalForm
} from '../../components/HelperComponents/StyledComponents';

import {
  BulmaSection,
  BulmaHero
} from '../../components/HelperComponents/HelperComponents';

import {
  ProfileEdit
} from '../ProfileEdit/ProfileEdit';

import {
  OrderHistory
} from '../OrderHistory/OrderHistory';

import personIcon from '../../images/person-icon.png';

import {
  getProfileInformation,
  parseBirthDate,
  logOutAction
} from '../../actions/UserActions';

class ProfileComponent extends Component {
  static propTypes = {
    children: PropTypes.any,
    match: PropTypes.any,
    location: PropTypes.any,
    dispatch: PropTypes.any,
    history: PropTypes.any,
    user: PropTypes.object
  };

  componentDidMount() {
    if (!this.props.user.authenticated) {
      this.props.history.push('/');
    } else {
      this.props.dispatch(getProfileInformation(this.props.user.data.token));
    }
  }

  render() {
    const userData = this.props.user.data ? this.props.user.data : {};

    const HeroHead = () => (
      <BulmaSection columnsClassName="is-multiline is-centered" >
        <section className="column is-11" style={{ zIndex: 1 }}>
          <ul className="has-text-white">
            <ProfileLi className="is-inline">
              <NavLink to="/profile" exact className="has-text-white" activeStyle={{ borderBottom: '1px solid #fff' }}>Profile</NavLink>
            </ProfileLi>
            <ProfileLi className="is-inline">
              <NavLink to="/profile/order-history" exact activeStyle={{ borderBottom: '1px solid #fff' }} className="has-text-white">Order History</NavLink>
            </ProfileLi>
          </ul>
        </section>
      </BulmaSection>
    );

    const ProfileView = () => (
      <BulmaSection columnsClassName="is-multiline is-centered">
        <section className="column is-full has-text-centered">
          <ProfileTitle><span className="is-capitalized">{userData.first_name}</span> <span className="is-capitalized">{userData.last_name}</span></ProfileTitle>
        </section>

        <VerticalForm className="column is-one-third">
          <section className="field user-info">
            <ProfileLabel>Full Name</ProfileLabel>
            <ProfileText><span className="is-capitalized">{userData.first_name}</span> <span className="is-capitalized">{userData.last_name}</span></ProfileText>
          </section>

          <section className="field user-info">
            <ProfileLabel>Email</ProfileLabel>
            <ProfileText>{userData.email}</ProfileText>
          </section>

          <section className="field user-info">
            <ProfileLabel>Birth Date</ProfileLabel>
            <ProfileText>{parseBirthDate(userData.birth_date)}</ProfileText>
          </section>

          <section className="field user-info">
            <ProfileLabel>Company</ProfileLabel>
            <ProfileText>{userData.company}</ProfileText>
          </section>

          <section className="field user-info">
            <ProfileLabel>Position</ProfileLabel>
            <ProfileText>{userData.position}</ProfileText>
          </section>

          <section className="field user-info">
            <ProfileLabel>Country</ProfileLabel>
            <ProfileText>{userData.country}</ProfileText>
          </section>

          <section className="field user-info">
            <ProfileLabel>Postal Code</ProfileLabel>
            <ProfileText>{userData.postcode}</ProfileText>
          </section>

          <section className="field user-info">
            <ProfileLabel>Address</ProfileLabel>
            <ProfileText>{userData.address}</ProfileText>
          </section>
        </VerticalForm>

        <section className="column is-full has-text-centered">
          <Link to="/profile/edit" className="has-text-white" style={{ marginRight: '1rem' }}>
            <PrimaryButton className="button is-rounded">
              Edit Profile
            </PrimaryButton>
          </Link>
          <PrimaryButton
            className="button is-rounded"
            onClick={() => this.props.logOutAction(this.props.history)}
            style={{ cursor: 'pointer' }}
          >
            Logout
          </PrimaryButton>
        </section>
      </BulmaSection>
    );

    const HeroFoot = (props) => (
      <Fragment>
        <ProfileHeroFooter style={{ display: props.showProfileImage }}>
          <figure className="image is-128x128">
            <img src={this.props.user.image || personIcon} alt="Profile" />
          </figure>
        </ProfileHeroFooter>
        <OrderHistoryH1 style={{ visibility: props.visibleTitle, paddingBottom: props.padding }}>{props.title}</OrderHistoryH1>
      </Fragment>
    );

    const ActiveTag = this.props.location.pathname === '/profile/order-history' ? <HeroFoot visibleTitle="visible" padding="1rem" title="Order Request History" showProfileImage="none" /> : <HeroFoot visibleTitle="hidden" title="Profile" showProfileImage="flex"/>;

    return (
      <Fragment>
        <BulmaHero head={<HeroHead></HeroHead>} foot={ActiveTag} backgroundColor="#191919"></BulmaHero>
        <Switch>
          <Route path={`${this.props.match.path}`} component={ProfileView} exact />
          <Route path={`${this.props.match.path}/edit`} component={ProfileEdit} exact/>
          <Route path={`${this.props.match.path}/order-history`} component={OrderHistory} exact />
          <Redirect to="/profile" />
        </Switch>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;

  return {
    user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators({ logOutAction }, dispatch)
  };
}

export const Profile = withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfileComponent));


// WEBPACK FOOTER //
// ./src/routes/Profile/Profile.js